import { Component, OnInit, Input } from '@angular/core';
import { ReportLine } from 'src/app/_objects/report-line';
import { Notifier, ReportTemplateDesignService, MousePoint } from 'src/app/_services/report-template-design.service';
import { FromToDetail } from 'src/app/_objects/report-template';
import { ElementType } from 'src/app/_objects/element-type';

@Component({
    selector: 'app-report-line-container',
    templateUrl: './report-line.component.html',
    styleUrls: ['./report-line.component.scss'],
    standalone: false
})
export class ReportLineComponent implements OnInit {

  @Input() pageKey: string;
  @Input() lineKey: string;
  @Input() public elementLocation: string;

  reportLine: ReportLine;
  private resizeMarkerSize: number;
  private resizing: boolean;
  private notifier: Notifier;
  public isCustomDrawEnable: boolean;

  constructor(
    public designService: ReportTemplateDesignService
  ) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  ngOnInit() {
    this.notifier = {
      componentName: 'report-line.component',
      ids: { pageId: this.pageKey, elementId: this.lineKey }
    };
    this.isCustomDrawEnable = this.designService.customElementAdd;
    this.reportLine = this.designService.getLine(this.lineKey);
    let elementNavigator = this.designService.navigatorElements
    .filter((x) => x.pageKey == this.pageKey)[0]
    .elementsDetails.filter((y) => y.location == this.elementLocation)[0]
      .elements;

     elementNavigator.filter(x=>x.elementName == ElementType.Line).length > 0
      ? elementNavigator.filter(x=>x.elementName == ElementType.Line)[0].elementData.push({
          id: this.lineKey,
          page: this.pageKey,
          name: this.reportLine.getTitle(),
        })
      : elementNavigator.push({
          elementName: ElementType.Line,
          isVisible: false,
          elementData: [
            {
              id: this.lineKey,
              page: this.pageKey,
              name: this.reportLine.getTitle(),
            },
          ],
        });
  }

  onClick(event: MouseEvent) {
    if (this.reportLine.isSelectable) {
      this.designService.notifySelectElement(this.notifier, this.lineKey, event.ctrlKey);
      event.stopPropagation();
    }
  }

  onDragStart(event: DragEvent) {
    // console.log('ReportLine onDragStart');
    event.dataTransfer.setData('text', this.lineKey);
    event.dataTransfer.effectAllowed = 'move';

    const fromDetail: FromToDetail = {
      location: this.reportLine.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    this.designService.notifyBeginDrag(this.notifier, ElementType.Line, fromDetail, dragPoint);
  }

  onDragOver(event: DragEvent) {
    // console.log('ReportLine onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    // console.log('ReportLine onDrop');
    event.preventDefault();
    const template  = {...this.designService.originTemplate};
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    this.designService.templateForUndo.push(template);
    const dragElemId = event.dataTransfer.getData('text');

    const toDetail: FromToDetail = {
      location: this.reportLine.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportLine.getLeftPx() + event.offsetX,
      onElementY: this.reportLine.getTopPx() + event.offsetY
    };

    this.designService.notifyDrop(this.notifier, dragElemId, toDetail, dropPoint);

    event.dataTransfer.clearData('text');
    event.stopPropagation();
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + 'px';
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case 'left':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'right':
        return (this.reportLine.getWidthPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    if (vertical === 'middle') {
      return ((this.reportLine.getHeightPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
    } else {
      return '';
    }
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    if (this.resizing) {
      this.designService.notifyResize(this.notifier, { onElementX: event.offsetX, onElementY: event.offsetY});
    }
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    this.designService.notifyBeginResize(this.notifier, ElementType.Text, horizontal, vertical, beginPoint);
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
